/* eslint-disable no-unused-vars */
import $DB from '../../util/debounce'
import QRCode from 'qrcodejs2'
export default {
  components: { QRCode },
  data() {
    return {
      agreement: '',
      isAgreement: false,
      consent: false, //是否同意
      activityList: [], //活动列表
      id: '', //活动ID
      isShow: false,
      codeTxt: '获取验证码',
      sending: true,
      second: 60,
      disabled: false,
      user: {
        act_name: '',
        act_phone: '',
        code: '',
      },
      isQrice: false,
      type: null, //判断是都免费
      orderId: null,
      time: null, //定时器
      navList: [
        { name: '微信支付', img: require('../../assets/image/activity/wx.png') },
        { name: '免费参加', img: require('../../assets/image/activity/free.png') },
      ],
      index: 0, //选择哪种祝福方式
    }
  },
  created() {
    this.sending = true
    this.getActivityList()
  },
  methods: {
    //获取协议信息
    getAgreement() {
      this.$axios.post('/api/ban/xy').then((res) => {
        if (res.data.code === 0) {
          this.agreement = res.data.data
        }
      })
    },
    //产看
    lookAgreement() {
      this.isAgreement = true
      this.getAgreement()
    },
    //同意
    changecontent() {
      this.isAgreement = false
      this.consent = true
    },
    //取消
    cancel() {
      this.isAgreement = false
    },
    changeConsent() {
      this.consent = !this.consent
    },
    //改变支付方式
    changeIndex(index) {
      this.index = index
    },
    //去详情
    goActivityMessage(id) {
      this.$router.push({ path: '/activityMessage', query: { id } })
    },
    //获取支付状态
    getPayState() {
      this.$axios
        .post('/api/users/applyId', {
          order_id: this.orderId,
        })
        .then((res) => {
          if (res.data.code === 0) {
            if (res.data.data == 1) {
              this.isQrice = false
              clearInterval(this.time)
              this.$router.push({ path: '/me' })
            }
          }
        })
    },
    //活动报名
    goApply(id, type) {
      if (!localStorage.getItem('incredible-k')) {
        this.$router.push('/login')
        return
      }
      this.consent = false
      this.user = {}
      this.type = type
      this.id = id
      this.isShow = true
    },
    //取消显示
    closeShow() {
      this.isQrice = false
      this.isShow = false
    },
    //提交信息
    submit: $DB(function () {
      if (!this.user.act_name) {
        this.$message.error('请输入姓名')
        return
      }
      if (!this.user.act_phone.match(/^(0|86|17951)?1[3456789]\d{9}$/)) {
        this.$message.error('请输入手机号')
        return
      }
      if (!this.user.code) {
        this.$message.error('请输入验证码')
        return
      }
      if (!this.consent) {
        this.$message.error('请勾选河南省芒果婚姻服务俱乐部协议')
        return
      }
      this.$axios
        .post('/api/users/apply', {
          ...this.user,
          act_id: this.id,
          type: 2,
        })
        .then((res) => {
          if (res.data.code === 0) {
            if (this.type == 1) {
              this.$router.push({ path: '/me' })
            } else {
              if (this.index == 0) {
                this.orderId = res.data.data.order_id
                this.isShow = false
                this.isQrice = true
                setTimeout(() => {
                  let qrcode = new QRCode('qrcode', {
                    width: 124,
                    height: 124, // 高度
                    text: res.data.data.pay_url, // 二维码内容
                    // text:res.data.data.pay_url ,   // 二维码内容
                    // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                    // background: '#f0f',   // 背景色
                    // foreground: '#ff0'    // 前景色
                  })
                  this.time = setInterval(() => {
                    this.getPayState()
                  }, 3000)
                }, 100)
              } else {
                this.$axios
                  .post('/api/users/yuePay', {
                    order_id: res.data.data.order_id,
                  })
                  .then((res) => {
                    if (res.data.code === 0) {
                      this.$router.push({ path: '/me' })
                    } else {
                      this.$message.error(res.data.msg)
                    }
                  })
              }
            }
          } else {
            this.$message.error(res.data.msg)
          }
          this.isShow = false
        })
    }),
    //获取活动列表
    getActivityList() {
      this.$axios.post('/api/index/actList').then((res) => {
        if (res.data.code === 0) {
          this.activityList = res.data.data
        }
      })
    },
    //获取验证码
    getCode: $DB(function () {
      if (!this.sending) return
      if (!this.user.act_phone) {
        this.$message.error('请输入正确的手机号')
        return
      }
      if (!this.user.act_phone.match(/^(0|86|17951)?1[3456789]\d{9}$/)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      this.$axios
        .post('/api/login/tel_code', {
          phone: this.user.act_phone,
        })
        .then((res) => {
          this.sending = false
          this.disabled = true
          if (res.data.code == 0) {
            this.timeDown()
            this.$message({
              message: res.data.msg,
              type: 'success',
            })
          } else {
            this.$message.error(res.data.msg)
          }
        })
    }),
    timeDown() {
      let result = setInterval(() => {
        --this.second
        this.codeTxt = this.second + 'S'
        if (this.second < 0) {
          clearInterval(result)
          this.sending = true
          this.disabled = false
          this.second = 60
          this.codeTxt = '获取验证码'
        }
      }, 1000)
    },
  },
}
